<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica media' : 'Nuovo media'"
                     @back="$router.replace('/media')" @saveback="save(true)" :loading="loading"></form-header>
        <v-col cols="12" >
          <h3>Info generali</h3>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Nome*"
              v-model="editingItem.name"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-select
              label="Tipologia*"
              v-model="editingItem.media"
              :items="mediatypes"
              :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="12" >
          <h3>File</h3>
        </v-col>
        <v-col cols="12" lg="5" xl="4">
          <v-file-input label="Seleziona file" v-model="file" clearable :accept="acceptType"></v-file-input>
        </v-col>
        <v-col cols="12">
          <p>o in alternativa:</p>
        </v-col>
        <v-col cols="12" lg="7" xl="6">
          <v-text-field label="URL" v-model="editingItem.url" :disabled="!!file" append-icon="mdi-eye" @click:append="openUrl()"></v-text-field>
          <p class="font-weight-bold" v-if="editingItem.media !== 'audio' && editingItem.media !== 'video'">ATTENZIONE! Accertati che le dimensioni siano corrette:</p>
          <ul v-if="editingItem.media !== 'audio' && editingItem.media !== 'video'">
            <li>icona: <strong>512x512</strong></li>
            <li>copertina: <strong>1280x720</strong></li>
            <li>banner: <strong>960x150</strong></li>
            <li>galleria: dimensione libera (sufficientemente grande)</li>
          </ul>
        </v-col>

        <form-footer @back="$router.replace('/media')" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import type { Media } from "@/models.ts";
import {mediatypes} from "@/consts.ts";
export default {
  components: {FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const loading = ref(false)

    const file = ref<File|undefined>()

    const editingItem = ref<Media>({
      media: "icon", name: "", url: ""
    })

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<Media>('media', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/media')
        return
      }
      editingItem.value = res.data!
      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      form,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      file,
      mediatypes,
      rules,
      formatDate : utils.formatDate,
      acceptType : computed(()=>{
        switch (editingItem.value.media) {
          case "icon":
          case "cover":
          case "gallery":
          case "banner":
            return ".jpg, .jpeg, .png"
          case "video":
            return ".mp4"
          case "audio":
            return ".mp3"
        }
      }),
      openUrl() {
        window.open(editingItem.value.url, '_blank')
      },
      async save(goBackAfterSave:boolean) {
        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;
        const res = await api.save<Media>('media', editingItem.value)
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        if(file.value) {
          let formData = new FormData();
          formData.append("media", file.value);
          const res = await api.upload<Media>( `media/${editingItem.value._id}/upload`, formData )
          if(!res.success) {
            loading.value = false
            messages.error(`Media salvato ma upload fallito: ${res.message ?? Msg.serverError}`)
            await globals.refresh('media')
            return
          }
          editingItem.value = res.data!
        }
        loading.value = false;
        messages.success("media salvato")
        await globals.refresh('media')
        if(goBackAfterSave) {
          await router.replace('/media')
        } else if(route.params.id === 'new'){
          await router.replace(`/media/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
